export default __webpack_public_path__ + "static/media/craftmen_gray_2.b82ad6bf.png";